import React from 'react'
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material'

const UnofficialTranslationNotice = ({ show, isInModal = false }) => {
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  if (!show) return null

  return (
    <Box
      sx={{
        // Both fixed and absolute position can be used based on context
        position: isInModal ? 'sticky' : 'fixed',

        // Position it at the bottom left of the viewport or modal
        bottom: isSmallScreen ? 20 : 25,
        left: isSmallScreen ? 20 : 25,

        // Higher z-index in modal to appear above modal content
        zIndex: isInModal ? 1400 : 1000,

        // Styling for the notification
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        color: 'white',
        padding: {
          xs: '6px 12px',
          sm: '8px 16px',
        },
        borderRadius: '8px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
        maxWidth: {
          xs: '170px',
          sm: '200px',
          md: '220px',
        },
        backdropFilter: 'blur(2px)',
        fontSize: {
          xs: '11px',
          sm: '12px',
          md: '14px',
        },
        fontWeight: 500,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: 0.9,
        transition: 'opacity 0.3s ease',
        pointerEvents: 'none', // Ensures it doesn't interfere with clicks
      }}
    >
      <Typography
        variant='body2'
        sx={{
          textAlign: 'center',
          fontSize: 'inherit',
          lineHeight: 1.3,
        }}
      >
        This is an unofficial / best effort translation
      </Typography>
    </Box>
  )
}

export default UnofficialTranslationNotice
